module.exports = __webpack_public_path__ + "static/img/property_1_gcash.5f19107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_gcash.png
// module id = mZkJ
// module chunks = 1